function filter01() {
    return [
        {
            fieldName: 'id',
            type: "value",
            value: 1
        }
    ]
}
function filterAnswer() {
    return [
        {
            fieldName: 'idJobPost',
            type: "value",
            value: localStorage.getItem("idJobPost")
        }
    ]
}
function filterSelector() {
    return [
        {
            fieldName: 'level',
            type: "value",
            value: 1
        }
    ]
}
export const customFilters = {
    filter01: filter01,
    filterAnswer: filterAnswer,
    filterSelector: filterSelector
    
};